/**
 * Returns a smaller extent centered within the given extent.
 * 
 * It shrinks the original extent by 1/4 on each side
 * (so the result covers half the width and height of the original box).
 *
 * @param {number[]} extent - An array of [minX, minY, maxX, maxY].
 * @returns {number[]|null} The inner extent, or null if input is invalid.
 */
export default function halfOfExtent(extent) {
  var diff1 = parseFloat(extent[2] - extent[0]) / 4;
  var diff2 = parseFloat(extent[3] - extent[1]) / 4;
  extent = [parseFloat(extent[0] + diff1), parseFloat(extent[1] + diff2), parseFloat(extent[2] - diff1), parseFloat(extent[3] - diff2)];
  return extent;
}
